export default __webpack_public_path__ + "static/media/2Klein.f39aed5e.jpg";